//ENVIAR VALOR NEGATIVO EN days PARA RESTAR DIAS

const addDaysToDate = (date, days) => {
    let res = new Date(date);
    res.setDate(res.getDate() + days);
    return res;
};

export default addDaysToDate;
